export default "__VITE_ASSET__d_KvfC0g__"